<template>
  <ProductPricePage
    :product="data.product"
    :product-data="data.productData"
    :subscription="subscription"
  >
    <NuxtPage
      :product="data.product"
      :product-data="data.productData"
      :subscription="subscription"
    />
  </ProductPricePage>
</template>

<script setup lang="ts">
import ProductPricePage from '~/components/market/ProductPricePage.vue'
import lithiumIonBatteriesData from '~/constants/price-assessments/unauthorized/lithium-ion-batteries'
import {
  LITHIUM_ION_BATTERIES,
  MARKET,
  SUBSCRIPTION_PRICE_ASSESSMENTS_LITHIUM_ION_BATTERIES,
} from '~/constants/services/constants'

/*-------------------------------------
  Meta
-------------------------------------*/
definePageMeta({ layout: 'services' })

const subscription = SUBSCRIPTION_PRICE_ASSESSMENTS_LITHIUM_ION_BATTERIES
const data = {
  product: {
    ...LITHIUM_ION_BATTERIES,
    name: 'Lithium ion Batteries',
  },
  productData: lithiumIonBatteriesData,
  subscription,
}

/*-------------------------------------
  SEO
-------------------------------------*/
const { getSeoInfo } = useSeo()
const seo = getSeoInfo({
  title: `${MARKET.name}: ${LITHIUM_ION_BATTERIES.name} Prices`,
})
useHead(seo)
</script>
